import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import axios from 'axios'
import VueAxios from 'vue-axios'

import Register from './helpers/register-components'
import can from "./helpers/can";

Vue.use(require('vue-moment'));

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

Vue.axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

Vue.config.productionTip = false

//register components
Register();

Vue.prototype.$can = can;

/*Vue.mixin({


});*/

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
